import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import FileNameValidationSchema from '../FileNameValidationSchema';
import { Validation } from '../Validation';

const { memberAssessmentPolicy } = loanFormModel.formField.hoaDocuments;

export class MemberAssessmentPolicyValidation implements ValidationSchema {
  public name = memberAssessmentPolicy.name;
  public label = '';
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public optional = true;

  public when(schema) {
    return FileNameValidationSchema(memberAssessmentPolicy.name, false);
  }
}
export default new Validation(new MemberAssessmentPolicyValidation());
